/*=========================================================================================
  File Name: i18nCommon.js
  Description: File đa ngôn ngữ chung
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
    Author: NCThanh1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	LinkApp: 'mtax.misa.vn',
	NameApp: "Thuế điện tử",
	ExtendFeature: 'Tính năng mở rộng',
	DeleteAllWarning: 'Bạn có thực sự muốn xóa tất cả các dòng đã nhập không?',
	AddDetail: 'Thêm dòng',
	DeleteAll: 'Xóa hết dòng',
	Cancel: 'Hủy',
	Save: 'Cất',
	Save2: 'Lưu',
	SavePrint: 'Cất và In',
	Print: 'In',
	Utilize: 'Tiện ích',
	DisplayAccount: 'Hiển thị tài khoản',
	SaveClose: 'Cất và Đóng',
	Feature: 'Chức năng',
	Filter: 'Lọc',
	UnFilter: 'Đặt lại',
	AdvanceFilter: 'Lọc nâng cao',
	Export: 'Xuất khẩu XML',
	View: 'Xem',
	ViewPDF: 'Xem PDF',
	ViewDetail: 'Xem chi tiết',
	Replication: 'Nhân bản',
	Delete: 'Xóa',
	ChooseReport: 'Chọn báo cáo',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	FromDateRequired: 'Từ ngày không được để trống',
	ToDateRequired: 'Đến ngày không được để trống',
	Agree: 'Đồng ý',
	Implement: 'Thực hiện',
	Total: 'Cộng',
	Add: 'Thêm',
	Finish: 'Hoàn thành',
	Back: 'Quay lại',
	SaveAdd: 'Cất và Thêm',
	From: 'Từ',
	To: 'Đến',
	Become: 'thành',
	Edit: 'Sửa',
	ClearCondition: 'Xóa điều kiện',
	Report: 'Báo cáo',
	Account: 'Tài khoản',
	Choose: 'Chọn',
	Delete: 'Xóa',
	Use: 'Sử dụng',
	StopUsing: 'Ngừng sử dụng',
	Menu: 'Tất cả danh mục',
	CollapseTooltip: 'Thu gọn',
	ExpandTooltip: 'Mở rộng',
	Term: 'Kỳ',
	Yes: 'Có',
	No: 'Không',
	Show: 'Có hiển thị',
	NotShow: 'Không hiển thị',
	Close: 'Đóng',
	Help: 'Giúp',
	RecentView: 'Xem gần đây',
	Description: 'Diễn giải',
	DescriptionServiceHistory: 'Mô tả',
	StopReason: 'Lý do ngừng dịch vụ',
	ClosePop: 'Hủy bỏ',
	Search: 'Tìm kiếm',
	InputSearch: 'Nhập để tìm kiếm',
	SearchDot: 'Tìm kiếm...',
	Here: 'tại đây',
	SeeHere: 'Xem tại đây',
	// filter
	All: 'Tất cả',
	Times: 'Thời gian',
	Status: 'Tình trạng',
	Status: 'Tình trạng',
	Status: 'Tình trạng',
	Branch: 'Chi nhánh',
	Of: 'của',
	// Thông báo khi không tìm thấy
	NotFound: 'Không tìm thấy.',
	Process: 'Quy trình',
	UnderConstruction: 'Tính năng đang trong quá trình phát triển',
	// Tham chiếu
	SearchFor: 'Tìm theo',
	Value: 'Giá trị',
	UpdateStatus: 'Cập nhật trạng thái',
	Update: 'Cập nhật',
	And: 'Và',
	Or: 'Hoặc',
	Contain: 'Chứa',
	NotContain: 'Không chứa',
	StartsWith: 'Bắt đầu với',
	EndsWith: 'Kết thúc với',
	ClearFilter: 'Bỏ lọc',
	ChooseFilterCondition: 'Chọn điều kiện lọc',
	ShowMore: 'Xem thêm',
	ShowLess: 'Thu gọn',
	Refresh: 'Tải lại',
	Detail: 'Chi tiết',
	EnterKeySearch: 'Nhập từ khóa tìm kiếm',
	Empty: 'Trống',
	NotEmpty: 'Không trống',
	Equal: 'Bằng',
	TotalSum: 'Tổng cộng',
	AddTaxPaper: 'Nộp Giấy nộp tiền',
	Draft: 'Lưu bản nháp',
	Active: 'Kích hoạt',
	Next: 'Tiếp theo',
	Input: 'Nhập',
	CancelRequest: 'Có lỗi xảy ra trong quá trình xử lý',
	Date: 'Ngày',
	Month: 'Tháng',
	Year: 'Năm',
	Quarter: 'Quý',
	Stage: 'Kỳ',
	TypeTaxPeriod: 'Loại kỳ tính thuế',
	ChangePopupClose:
		'Dữ liệu chưa được lưu.</br> Bạn có chắc chắn muốn hủy bỏ?',
	CreatedDate: 'Ngày nộp',
	Status: 'Trạng thái',
	noData: 'Không có bản ghi nào',
	SaveDraftSuccess: 'Lưu nháp thành công',
	BackHome: 'Quay lại trang chủ',
	Unauthorized: 'Bạn không có quyền truy cập',
	SessionChanged:
		'Phiên làm việc đã thay đổi. Vui lòng tải lại trang để tiếp tục.',
	ConfigLayout: 'Thiết lập cột',
	NoDataFilter: 'Không tìm thấy kết quả nào',
	ErrorCertificate:
		'Chứng thư số không đúng. Bạn phải dùng chứng thư số đã đăng ký sử dụng dịch vụ nộp thuế điện tử để ký.',
	ErrorExpiredCertificate: (DateSign, DateStart, DateEnd) =>
		`Ngày ký điện tử là ${DateSign} không thuộc khoảng thời gian hiệu lực của chứng thư ( từ ${DateStart} đến ${DateEnd} ).`,
	NotFoundCertificate:
		'Không tìm thấy chứng thư số. Vui lòng kiểm tra lại USB Token của bạn.',
	TokenExprireDate: 'Chứng thư số hết hiệu lực. Vui lòng kiểm tra lại.',
	ErrorFormal: 'Đã có lỗi xảy ra. Vui lòng kiểm tra lại.',
	SignedError: 'Ký số không thành công. Vui lòng kiểm tra lại file đính kèm.',
	Download: 'Tải về',
	ReSubmit: 'Nộp lại',
	ViewNotification: 'Xem thông báo',
	OnCapsLock: 'Đang bật Caps Lock',
	NoFilterData: 'Không tìm thấy dữ liệu',
	GetInfo: 'Lấy thông tin',
	NotAuthorized: 'Bạn không có quyền thực hiện tính năng này!',
	PageNotFound: 'Trang không tồn tại',
	InternalServer: 'Có lỗi xảy ra trong quá trình xử lý',
	SignIn: 'Đăng nhập',
	Export: 'Xuất khẩu',
	Code: 'Mã',
	Name: 'Tên',
	NameTaxAgentControl: 'Tên cơ quan thuế quản lý',
	NameTaxAgentPayer: 'Tên cơ quan quản lý thu',
	BuyNow: 'Mua ngay',
	BuyMore: 'Mua thêm',
	Accept: 'Xác nhận',
	AcceptPay: 'Xác nhận thanh toán',
	CancelOrder: 'Hủy đơn hàng',
	HelpPayment: 'Hướng dẫn thanh toán',
	Help: 'Hướng dẫn',
	CompanyMisa: 'Công ty cổ phần MISA',
	BankACB: 'Hội Sở ngân hàng TMCP Á Châu',
	NoFilePath: 'Không có đường dẫn file.',
	SelectFile: 'Chọn tệp',
	UseService: 'sử dụng dịch vụ',
	Change: 'thay đổi',
	StopService: 'ngừng dịch vụ',
	SetDefault: 'Mặc định',
	RegisterHere: 'Đăng ký ngay tại đây',
	Here: 'tại đây.',
	UpdateSuccess: 'Cập nhật thành công.',
	UpdateFail: 'Cập nhật thất bại.',
	GetData: 'Lấy dữ liệu',
	NextWorking: 'Đã hiểu, tiếp tục làm việc',
	TaxPaper: 'Nộp thuế',
	NextStep: 'Tiếp tục',
	SendReport: 'Gửi phản hồi',
	Dismiss: 'Bỏ qua',
	ErrorWanrning: 'Có lỗi trong quá trình xử lý. Vui lòng liên hệ MISA để được hỗ trợ',
	Note:'Lưu ý',
	Notification: 'Thông báo',
	CTSTamKhoa: 'Không thể thực hiện ký số do chứng thư số này đang bị tạm dừng. Vui lòng liên hệ MISA để được hỗ trợ.',
	KysoNotWorking: {
		Title: 'Công cụ MISA KYSO chưa hoạt động',
		Description: 'Vui lòng thực hiện theo hướng dẫn dưới đây để có thể ký số trên phần mềm.',
		SetupPermissionPrefix: 'Thiết lập quyền',
		SetupPermissionSuffix: 'trên trình duyệt web đang sử dụng để cho phép kết nối đến công cụ',
		MisaKyso: 'MISA KYSO',
		ViewGuide: 'Xem hướng dẫn',
		Close: 'Đóng',
		DownloadInstaller: 'Tải bộ cài MISA KYSO',
		NotInstalledTextPrefix: 'Nếu chưa cài công cụ',
		NotInstalledTextSuffix: ', hãy cài đặt ngay.',
	},
	MISAKySo: {
		TokenRevokeTitle: 'Chứng thư số đã bị thu hồi',
		TokenRevokeMessage: 'Vui lòng liên hệ nhà cung cấp chứng thư số để được cấp chứng thư số mới, sau đó kết nối chứng thư số mới trong phần Hệ thống/Thiết lập chữ ký số.',
		TokenRevokeActionSetting: 'Thiết lập chữ ký số'
	},
	agreement: {
		validationError: "Vui lòng tích vào lựa chọn này trước khi nhấn 'Tiếp theo'",
		errorLoadPolicy: 'Không thể tải thông tin chính sách. Vui lòng thử lại.',
	},
	UserDataChanged: 'Dữ liệu người dùng đã thay đổi. Vui lòng tải lại trang để cập nhật thông tin.',
	Refresh: 'Tải lại',
};